<template>
  <div class="directory-node">
    <div
      class="directory-item"
      :class="{ 'selected': selectedDir && selectedDir.id === dir.id }"
      :style="{ paddingLeft: (level * 20 + 10) + 'px' }"
      v-draggable="dir.id"
      v-droppable="handleDropIn"
      :data-dir-id="dir.id"
      @click.stop="handleSelect"
    >
      <Icon
        v-if="hasChildren"
        :type="expanded ? 'md-remove' : 'md-add'"
        class="expand-icon"
        @click.stop="expanded = !expanded"
      />
      <span v-else class="expand-placeholder"></span>
      <Icon :type="getDirectoryIcon(dir)" style="margin-right:5px;" />
      <span class="directory-name">{{ dir.name }}</span>
      <BaseIcon v-if="dir.type === 'private' || dir.is_private" icon="md-lock" :size="14" class="dir-badge-icon" style="margin-left:5px;" />
      <BaseIcon v-if="dir.type === 'link-dir' || dir.type === 'remote'" icon="lianjie" :size="14" class="dir-badge-icon" style="margin-left:5px;" />
      <span v-if="dir.type === 'system'" class="system-badge">系统</span>
      <span v-if="dir.type === 'link-dir' || dir.type === 'remote'" class="link-badge">链接</span>
    </div>
    <div v-if="expanded && hasChildren" class="directory-children">
      <directory-node
        v-for="child in dir.subs"
        :key="child.id"
        :dir="child"
        :selected-dir="selectedDir"
        :level="level + 1"
        @on-select="$emit('on-select', $event)"
        @on-drop-in="$emit('on-drop-in', $event)"
        @on-drop-file="$emit('on-drop-file', $event)"
      />
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/Icon';

export default {
  name: 'DirectoryNode',
  components: {BaseIcon},
  props: {
    dir: {
      type: Object,
      required: true,
    },
    selectedDir: {
      type: Object,
      default: null,
    },
    level: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      expanded: this.level < 2, // 默认展开前两级
    };
  },
  computed: {
    hasChildren() {
      return this.dir.subs && this.dir.subs.length > 0;
    },
  },
  methods: {
    getDirectoryIcon(dir) {
      if (dir.type === 'system') {
        return 'md-settings';
      } else if (dir.type === 'link-dir' || dir.type === 'remote') {
        return 'md-link';
      } else {
        return 'md-folder';
      }
    },
    handleSelect() {
      this.$emit('on-select', this.dir);
    },
    handleDropIn(draggedId, targetData) {
      // 判断是目录还是文件
      // 如果draggedId是目录ID（在directories中能找到），则触发目录拖拽事件
      // 否则触发文件拖拽事件
      this.$emit('on-drop-in', {
        draggedId,
        targetDirId: targetData.dirId,
      });
      // 同时触发文件拖拽事件，让父组件判断
      this.$emit('on-drop-file', {
        draggedId,
        targetDirId: targetData.dirId,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.directory-node {
  .directory-item {
    padding: 8px 10px;
    margin: 2px 0;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s;
    user-select: none;
    position: relative;

    &:hover {
      background: var(--border);
    }

    &.selected {
      background: var(--primary);
      color: #fff;

      .link-badge {
        background: rgba(255, 255, 255, 0.3);
      }
    }

    .expand-icon {
      width: 16px;
      height: 16px;
      margin-right: 5px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid var(--border);
      border-radius: 2px;
    }

    .expand-placeholder {
      width: 16px;
      margin-right: 5px;
    }

    .directory-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .link-badge {
      font-size: 10px;
      padding: 2px 6px;
      background: var(--subtext3);
      color: #fff;
      border-radius: 2px;
      margin-left: 5px;
    }
    
    .system-badge {
      font-size: 10px;
      padding: 2px 6px;
      background: var(--primary);
      color: #fff;
      border-radius: 2px;
      margin-left: 5px;
    }
    
    .dir-badge-icon {
      color: var(--subtext2);
      
      .selected & {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  .directory-children {
    margin-left: 0;
  }
}

.ugo-draggable {
  opacity: 0.5;
}

.ugo-droppable {
  background: var(--primary-light) !important;
  border: 2px dashed var(--primary) !important;
}
</style>

